import { render, staticRenderFns } from "./LikedBox.vue?vue&type=template&id=683a613b&scoped=true"
import script from "./LikedBox.vue?vue&type=script&lang=js"
export * from "./LikedBox.vue?vue&type=script&lang=js"
import style0 from "./LikedBox.vue?vue&type=style&index=0&id=683a613b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a613b",
  null
  
)

export default component.exports